module.exports = __webpack_public_path__ + "img/GOAL.78a1b821.svg";